import { getAdminRoutePermission } from '../../adminRoutes';

const createLink = getAdminRoutePermission((x) => x.rateNew);
const editLink = getAdminRoutePermission((x) => x.rateEdit);

export const rateListPermissions = {
    createLink,
    editLink,
};
